(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["artpixe-promo-activation"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.querySelector('[data-apx-promo-config]');
  if (!config) return;
  const messages = config.dataset;
  const root = messages.root.replace(/\/?$/, '/');
  const code = 'C10';
  const entries = new Map();
  let pending = false;
  let syncing = false;

  async function request(path, options = {}) {
    const response = await fetch(root + path, {
      credentials: 'same-origin', cache: 'no-store',
      ...options, signal: AbortSignal.timeout(10000)
    });
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }

  function applications(cart) {
    return [
      ...(cart.cart_level_discount_applications || []),
      ...(cart.items || []).flatMap(item =>
        (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application)
      )
    ].filter(Boolean);
  }

  function existingCodes(cart) {
    return [...new Set([
      ...(cart.discount_codes || []).map(discount => discount.code),
      ...applications(cart).filter(discount => discount.type === 'discount_code').map(discount => discount.title)
    ].filter(value => typeof value === 'string' && value.length).map(value => value.toUpperCase()))];
  }

  function isApplied(cart) {
    return applications(cart).some(discount =>
      String(discount.title).toUpperCase() === code && Number(discount.total_allocated_amount) > 0
    ) || (cart.items || []).some(item =>
      (item.line_level_discount_allocations || []).some(allocation =>
        String(allocation.discount_application?.title).toUpperCase() === code && Number(allocation.amount) > 0
      )
    ) || (cart.discount_codes || []).some(discount =>
      String(discount.code).toUpperCase() === code && discount.applicable === true && cart.item_count > 0
    );
  }

  function display(buttonText, statusText = '') {
    entries.forEach(({button, status}) => {
      button.textContent = buttonText;
      button.setAttribute('aria-disabled', String(pending));
      button.setAttribute('aria-busy', String(pending));
      status.textContent = statusText;
    });
  }

  async function sync() {
    if (pending || syncing || !entries.size) return;
    syncing = true;
    try {
      const cart = await request('cart.js');
      if (!pending) display(isApplied(cart) ? messages.applied : messages.activate);
    } catch {} finally { syncing = false; }
  }

  async function activate() {
    if (pending) return;
    pending = true;
    display(messages.loading);
    try {
      const before = await request('cart.js');
      const codes = [...new Set([...existingCodes(before), code])];
      const cart = await request('cart/update.js', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({discount: codes.join(',')})
      });
      pending = false;
      if (isApplied(cart)) display(messages.applied, messages.confirmation);
      else if (cart.item_count === 0) display(messages.saved, messages.empty);
      else display(messages.activate, messages.ineligible);
      document.dispatchEvent(new CustomEvent('artpixe:discount-applied', {detail: {cart}}));
    } catch {
      pending = false;
      display(messages.activate, messages.error);
    }
  }

  function initialize() {
    document.querySelectorAll('.apb').forEach(banner => {
      if (entries.has(banner) || banner.dataset.apxActivation || !banner.querySelector('.apb-code')) return;
      if (!Array.from(banner.querySelectorAll('.apb-code')).some(el => el.textContent.trim() === code)) return;
      banner.dataset.apxActivation = 'true';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'apx-promo-activate';
      button.textContent = messages.activate;
      const status = document.createElement('p');
      status.className = 'apx-promo-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      banner.append(button);
      banner.insertAdjacentElement('afterend', status);
      entries.set(banner, {button, status});
      banner.addEventListener('click', event => {
        if (event.target.closest('a')) return;
        activate();
      });
    });
    for (const [banner] of entries) if (!banner.isConnected) entries.delete(banner);
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', sync);
})();
  } catch(e) { console.error(e); }
})();

})();
